import React from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Gallery = () => {
  const gallery1 = "https://i.ibb.co/jgZ55YJ/Apple-i-Phone-6s.png";
  const gallery2 = "https://i.ibb.co/f4FY0ym/R-nokia-3310-black.png";
  const gallery3 = "https://i.ibb.co/prTTjTW/R-i-Phone-12-pro.png";
  const gallery4 = "https://i.ibb.co/rykhMBR/R-Walton-Primo-RM2.png";
  const gallery5 = "https://i.ibb.co/y8P1bLr/vivo-y20.png";
  const gallery6 = "https://i.ibb.co/NY82nq8/R-symphony-D54.png";

  return (
    <div>
      <section className="overflow-hidden text-neutral-700">
        <div className="container mx-auto py-2 lg:px-5 lg:p-5">
          <div className="-m-1 flex flex-wrap md:-m-2">
            <div className="flex w-1/2 flex-wrap">
              <div className="w-1/2 p-1 md:p-2">
                <PhotoProvider
                  speed={() => 800}
                  easing={(type) =>
                    type === 2
                      ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                      : "cubic-bezier(0.34, 1.56, 0.64, 1)"
                  }
                >
                  <PhotoView src={gallery1}>
                    <figure>
                      <LazyLoadImage
                        src={gallery1}
                        alt="Apple iPhone 6"
                        className="block h-full w-full rounded-[5px] object-cover object-center common-left"
                        placeholderSrc={gallery1}
                        effect="blur"
                        title="Apple iPhone 6"
                        style={{ objectFit: "cover", cursor: "pointer" }}
                      />
                    </figure>
                  </PhotoView>
                </PhotoProvider>
              </div>

              <div className="w-1/2 p-1 md:p-2">
                <PhotoProvider
                  speed={() => 800}
                  easing={(type) =>
                    type === 2
                      ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                      : "cubic-bezier(0.34, 1.56, 0.64, 1)"
                  }
                >
                  <PhotoView src={gallery2}>
                    <figure>
                      <LazyLoadImage
                        src={gallery2}
                        alt="Nokia 3310"
                        className="block h-full w-full rounded-[5px] object-cover object-center common-top"
                        placeholderSrc={gallery2}
                        effect="blur"
                        title="Nokia 3310"
                        style={{ objectFit: "cover", cursor: "pointer" }}
                      />
                    </figure>
                  </PhotoView>
                </PhotoProvider>
              </div>

              <div className="w-full p-1 md:p-2">
                <PhotoProvider
                  speed={() => 800}
                  easing={(type) =>
                    type === 2
                      ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                      : "cubic-bezier(0.34, 1.56, 0.64, 1)"
                  }
                >
                  <PhotoView src={gallery3}>
                    <figure>
                      <LazyLoadImage
                        src={gallery3}
                        alt="Apple iPhone 12 Pro"
                        className="block h-full w-full rounded-[5px] object-cover object-center common-bottom"
                        placeholderSrc={gallery3}
                        effect="blur"
                        title="Apple iPhone 12 Pro"
                        style={{ objectFit: "cover", cursor: "pointer" }}
                      />
                    </figure>
                  </PhotoView>
                </PhotoProvider>
              </div>
            </div>

            <div className="flex w-1/2 flex-wrap">
              <div className="w-full p-1 md:p-2">
                <PhotoProvider
                  speed={() => 800}
                  easing={(type) =>
                    type === 2
                      ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                      : "cubic-bezier(0.34, 1.56, 0.64, 1)"
                  }
                >
                  <PhotoView src={gallery4}>
                    <figure>
                      <LazyLoadImage
                        src={gallery4}
                        alt="Walton Primo RM2"
                        className="block h-full w-full rounded-[5px] object-cover object-center common-top"
                        placeholderSrc={gallery4}
                        effect="blur"
                        title="Walton Primo RM2"
                        style={{ objectFit: "cover", cursor: "pointer" }}
                      />
                    </figure>
                  </PhotoView>
                </PhotoProvider>
              </div>

              <div className="w-1/2 p-1 md:p-2">
                <PhotoProvider
                  speed={() => 800}
                  easing={(type) =>
                    type === 2
                      ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                      : "cubic-bezier(0.34, 1.56, 0.64, 1)"
                  }
                >
                  <PhotoView src={gallery5}>
                    <figure>
                      <LazyLoadImage
                        src={gallery5}
                        alt="Realme C17"
                        className="block h-full w-full rounded-[5px] object-cover object-center common-top"
                        placeholderSrc={gallery5}
                        effect="blur"
                        title="Realme C17"
                        style={{ objectFit: "cover", cursor: "pointer" }}
                      />
                    </figure>
                  </PhotoView>
                </PhotoProvider>
              </div>

              <div className="w-1/2 p-1 md:p-2">
                <PhotoProvider
                  speed={() => 800}
                  easing={(type) =>
                    type === 2
                      ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                      : "cubic-bezier(0.34, 1.56, 0.64, 1)"
                  }
                >
                  <PhotoView src={gallery6}>
                    <figure>
                      <LazyLoadImage
                        src={gallery6}
                        alt="Symphony D54"
                        className="block h-full w-full rounded-[5px] object-cover object-center common-top"
                        placeholderSrc={gallery6}
                        effect="blur"
                        title="Symphony D54"
                        style={{ objectFit: "cover", cursor: "pointer" }}
                      />
                    </figure>
                  </PhotoView>
                </PhotoProvider>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
